<template>
  <v-card>
    <v-toolbar
      dark
      flat
      :color="formColour"
    >
      <v-toolbar-title><v-icon>error</v-icon> {{ errorTitle }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text class="pt-5">
      <p v-html="errorText"></p>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        :color="formColour"
        text
        @click="close"
        >
        OK
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { AppColor } from '@/config.js'

export default {
  name: 'AppError',
  data: () => ({
    appColor_Error: AppColor.Error,
    appColor_Warning: AppColor.Warning
  }),
  props: {
    errorTitle: {
      type: String,
      default: null
    },
    errorText: {
      type: String,
      default: null
    },
    errorSeverity: {
      type: String,
      default: null
    }
  },
  computed: {
    formColour () {
      return this.errorSeverity === 0
        ? this.appColor_Warning
        : this.appColor_Error
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
